module.exports = __webpack_public_path__ + "media/images/riders/small/EDWARD_MASTERS-3b2bc1828de487aa9da4399813bc969b.png";